var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 13C33.5 13.3647 33.3551 13.7144 33.0973 13.9723C32.8394 14.2301 32.4897 14.375 32.125 14.375H1.875C1.51033 14.375 1.16059 14.2301 0.902728 13.9723C0.644866 13.7144 0.5 13.3647 0.5 13C0.5 12.6353 0.644866 12.2856 0.902728 12.0277C1.16059 11.7699 1.51033 11.625 1.875 11.625H32.125C32.4897 11.625 32.8394 11.7699 33.0973 12.0277C33.3551 12.2856 33.5 12.6353 33.5 13ZM1.875 3.375H32.125C32.4897 3.375 32.8394 3.23013 33.0973 2.97227C33.3551 2.71441 33.5 2.36467 33.5 2C33.5 1.63533 33.3551 1.28559 33.0973 1.02773C32.8394 0.769866 32.4897 0.625 32.125 0.625H1.875C1.51033 0.625 1.16059 0.769866 0.902728 1.02773C0.644866 1.28559 0.5 1.63533 0.5 2C0.5 2.36467 0.644866 2.71441 0.902728 2.97227C1.16059 3.23013 1.51033 3.375 1.875 3.375ZM32.125 22.625H1.875C1.51033 22.625 1.16059 22.7699 0.902728 23.0277C0.644866 23.2856 0.5 23.6353 0.5 24C0.5 24.3647 0.644866 24.7144 0.902728 24.9723C1.16059 25.2301 1.51033 25.375 1.875 25.375H32.125C32.4897 25.375 32.8394 25.2301 33.0973 24.9723C33.3551 24.7144 33.5 24.3647 33.5 24C33.5 23.6353 33.3551 23.2856 33.0973 23.0277C32.8394 22.7699 32.4897 22.625 32.125 22.625Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.850db08a323db5da8d0be6ae4e8b77bc.svg";
export { ForwardRef as ReactComponent };